import { render } from "./SideNavigationBar.vue?vue&type=template&id=5ef39a8e"
import script from "./SideNavigationBar.vue?vue&type=script&lang=js"
export * from "./SideNavigationBar.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Project Repository\\11-Isomat\\code\\services\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__